import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom';

class Single extends Component {

    getList() {
        const list = this.props.posts;
        return list.map(({key, photo, title}) => this.getSingle(key, photo, title));
    }

    getSingle(key, photo, title) {
        throw "Implement get single";
    }

    componentDidUpdate() {
        if (this.props.posts.length > 0) {
            this.firstUpdate();
        }
    }

    firstUpdate() {
        throw "Implement first update";
    }

    render() {
        return (
            <Fragment>
                {this.getList()}
            </Fragment>
        );
    }

}

export class Articles extends Single {

    getSingle(key, photo, title) {
        const link = `/blog/${key}`;
        return (
            <article key={key}>
                <Link to={link}>
                    <img src={photo} alt={title}/>
                </Link>
                <div className="details">
                    <h5 className="bold uppercase">
                        <Link to={link}>{title}</Link>
                    </h5>
                </div>
            </article>
        );
    }


    firstUpdate() {
        const element = document.querySelector('.masonry.blog');
        window.imagesLoaded(element, () => element.masonry.update());
    }
}

export class Works extends Single {

    getSingle(key, photo, title) {
        const link = `/portfolio/${key}`;
        return (
            <Link to={link} className="portfolio-item" data-background={photo} key={key}>
                <figcaption>
                    <h5 className="item-title">
                        {title}
                    </h5>
                </figcaption>
            </Link>
        );
    }


    firstUpdate() {
        const element = document.querySelector('.grid.lightbox');
        window.imagesLoaded(element, () => element.masonry.update());
        [].forEach.call(document.querySelectorAll('.grid [data-background]'), function(item){
            item.style.backgroundImage = 'url('+item.getAttribute('data-background')+')';
        });
    }

}


// WEBPACK FOOTER //
// ./src/visitors/components/SinglePost.js